import type { Editor } from "@tiptap/core";

/** Keep the visible passage in place, including when switching between preview and editor. */
export function keepSummaryReadingPosition(editor: Editor, update: () => void, getReplacement?: () => Editor | undefined) {
  const scroller = editor.view.dom.closest<HTMLElement>("main");
  if (!scroller) { update(); return; }
  const scrollTop = scroller.scrollTop;
  const top = scroller.getBoundingClientRect().top + (scroller.querySelector(".page-header")?.getBoundingClientRect().height ?? 0);
  const children = Array.from(editor.view.dom.children);
  const anchor = children.find(element => element.getBoundingClientRect().bottom > top);
  const anchorIndex = anchor ? children.indexOf(anchor) : -1;
  const anchorNode = getReplacement && anchorIndex >= 0 ? editor.state.doc.maybeChild(anchorIndex) : null;
  const anchorTop = anchor?.getBoundingClientRect().top;
  try { update(); }
  finally {
    let visibleAnchor = anchor?.isConnected && anchor.getClientRects().length ? anchor : undefined;
    const replacement = getReplacement?.();
    if (!visibleAnchor && replacement && replacement !== editor && anchorNode) {
      const node = replacement.state.doc.maybeChild(anchorIndex);
      const element = replacement.view.dom.children[anchorIndex];
      // Preview and saved editor render the same snapshot. Preserve the passage
      // across the switch as well, including the disappearing preview label.
      if (node?.type.name === anchorNode.type.name && node.textContent === anchorNode.textContent && element?.getClientRects().length) visibleAnchor = element;
    }
    const next = visibleAnchor && anchorTop !== undefined
      ? scrollTop + visibleAnchor.getBoundingClientRect().top - anchorTop : scrollTop;
    if (Math.abs(scroller.scrollTop - next) > 0.5) scroller.scrollTop = next;
  }
}

